"use strict";
/**
 * Health & Metrics Types
 * Unified health check and readiness probe interfaces for all platform services
 */
Object.defineProperty(exports, "__esModule", { value: true });
